export function fromBackupProgramEntryToStoredProgramType(original) {
  if (!original) return null;
  return {
    label: original.programName,
    logo: original.logo,
    programId: original.backupProgramId,
    programName: original.programName,
    schoolId: 0,
    schoolName: original.schoolName,
    value: original.backupProgramId
  };
}